import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Reusable Components
import TransparentBlogCard from "reusables/Cards/BlogCards/TransparentBlogCard";
import BackgroundBlogCard from "reusables/Cards/BlogCards/BackgroundBlogCard";
import SubTitleContents from "reusables/TextFormats/SubTitleContents";

// Images
import regular1 from "assets/images/Services/Accommodation/regular1.jpg";
import regular2 from "assets/images/Services/Accommodation/regular2.jpg";
import regular4 from "assets/images/Services/Accommodation/regular4.jpg";
import regular5 from "assets/images/Services/Accommodation/regular5.jpg";

function Accommodation_Section1() {
  return (
    <Container>
      <SubTitleContents title="Regular Cleaning Plans" contents="" />
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} lg={3} textAlign="justify" wordbreak="break-all">
          <TransparentBlogCard
            image={regular2}
            title="Daily Cleaning"
            description="Maintain a spotless and inviting space for your guests with our daily cleaning service. Ideal for hotels, Airbnbs, and holiday homes, it ensures every guest arrives to a clean and welcoming environment."
            // action={{
            //   type: "internal",
            //   route: "/",
            //   color: "info",
            //   label: "read more",
            // }}
            popular={true}
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={3} textAlign="justify" wordbreak="break-all">
          <TransparentBlogCard
            image={regular4}
            title="Weekly Cleaning"
            description="Designed for properties with longer guest stays or moderate turnover, our weekly cleaning service keeps your accommodation fresh, tidy, and guest-ready throughout the week."
            // action={{
            //   type: "internal",
            //   route: "/",
            //   color: "info",
            //   label: "read more",
            // }}
            // popular={false}
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={3} textAlign="justify" wordbreak="break-all">
          <TransparentBlogCard
            image={regular5}
            title="Monthly Cleaning"
            description="Provide your space with a comprehensive refresh through our monthly cleaning service. Perfect for holiday homes and rentals, it ensures deep cleanliness and upkeep for properties with less frequent use."
            // action={{
            //   type: "internal",
            //   route: "/",
            //   color: "info",
            //   label: "read more",
            // }}
            // popular={false}
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={3}>
          <BackgroundBlogCard
            image={regular1}
            title="Tailored Cleaning Plans"
            description="Customized cleaning schedules designed to fit your unique needs and lifestyle-flexible, reliable, and just the way you like it"
          />
        </Grid>
      </Grid>
    </Container>
  );
}

export default Accommodation_Section1;
